import React from 'react';
import { Card, Accordion } from 'react-bootstrap';
import { DebounceInput } from "react-debounce-input";
import NumberToPersianWord from "number_to_persian_word";
import { NumToFa} from "../../Functions/TextTransform";


export default function Step5CTrackPleatedSheer({
 ContextAwareToggle,
 requiredStep,
 stepSelectedLabel,
 setDeps,
 setCart,
 t,
 step3,
 step31,
 step3ATrack,
 step3ARod1,
 depSet,
 accordionActiveKey,
 step3A0,
 rodToBottom,
 setRodToBottom,
 setCartLoading,
 optionSelectChanged,
 selectChanged,
 pageLanguage,
 NextStep,
}) {
  return (
   <Card
   className={
     step3 === "true" &&
     step31 === "Track" &&
     (step3ATrack === "Sill" || (step3ATrack === "Apron" && step3ARod1 === "true"))
       ? ""
       : "noDisplay"
   }
 >
   <Card.Header
     className={
       [...depSet].findIndex((el) => el.startsWith("3")) === -1 &&
       !accordionActiveKey.startsWith("3")
         ? "hidden"
         : ""
     }
   >
     <ContextAwareToggle
       eventKey="3C"
       stepNum={t("4C")}
       stepTitle={t("pleated_step3DRod_Apron")}
       stepRef="3CRod"
       type="2"
       required={requiredStep["3CRod"]}
       stepSelected={
         stepSelectedLabel["3CRod"] === undefined ? "" : stepSelectedLabel["3CRod"]
       }
     />
   </Card.Header>
   <Accordion.Collapse eventKey="3C">
     <Card.Body>
       <div className="card_body">
         <div className="box100">
           <p className="step_selection_title">{t("pleated_step3DRod_title_Apron")}</p>
           <img
             src={
               pageLanguage === "fa"
                 ? step3A0 === "Moulding"
                   ? require("../../Images/drapery/grommet/RodToBottom_arc_fa.svg").default
                   : require("../../Images/drapery/grommet/RodToBottom_fa.svg").default
                 : step3A0 === "Moulding"
                 ? require("../../Images/drapery/grommet/RodToBottom_arc.svg").default
                 : require("../../Images/drapery/european/5c.svg").default
             }
             className="img-fluid just_frame"
             alt=""
           />
         </div>
         <div className="box100 Three_selection_container">
           <div className="box100">
             <div className="measure_input_container">
               <h1 className="measure_input_label">{t("Height")}</h1>
               <div className="measure_input_field_container">
                 <DebounceInput
                   debounceTimeout={1500}
                   autoComplete="off"
                   onKeyDown={(e) => {
                     if (
                       !/[0-9]/.test(NumberToPersianWord.convertPeToEn(e.key)) &&
                       e.keyCode !== 8 &&
                       e.keyCode !== 46 &&
                       e.keyCode !== 37 &&
                       e.keyCode !== 39 &&
                       e.keyCode !== 13
                     ) {
                       e.preventDefault();
                     }
                   }}
                   className={
                     "measure_input" +
                     (rodToBottom !== undefined &&
                     (rodToBottom < 1 || rodToBottom > 1000)
                       ? " measure_input_err"
                       : "")
                   }
                   type="text"
                   name="rodToBottom1"
                   value={NumToFa(`${rodToBottom || ""}`, pageLanguage)}
                   onChange={(e) => {
                     setTimeout(() => {
                       let newValue = NumberToPersianWord.convertPeToEn(e.target.value);
                       newValue = isNaN(newValue) ? "" : newValue;
                       if (
                         newValue &&
                         newValue !== "" &&
                         parseInt(newValue) >= 1 &&
                         parseInt(newValue) <= 1000
                       ) {
                         setCartLoading(true);
                         setCart("RodToBottom", parseInt(newValue));
                         setDeps("", "3CRod");
                         setRodToBottom(parseInt(newValue));
                         optionSelectChanged(
                           "3CRod",
                           parseInt(newValue),
                           "cm",
                           "س\u200Cم",
                           pageLanguage
                         );
                       } else {
                         setCartLoading(true);
                         setCart("", "", "RodToBottom");
                         setDeps("3CRod", "");
                         if (newValue === "" || isNaN(parseInt(newValue))) {
                           setRodToBottom(undefined);
                           selectChanged(undefined, "3CRod");
                         } else {
                           setRodToBottom(parseInt(newValue));
                           selectChanged("3CRod", undefined, t("Invalid Measurements"));
                         }
                       }
                     }, 300);
                   }}
                 />
                 <div className="measure_input_postfix">{t("cm_label")}</div>
               </div>
             </div>
           </div>
         </div>
         <NextStep currentStep="3CRod" eventKey="3D">
           {t("NEXT STEP")}
         </NextStep>
       </div>
     </Card.Body>
   </Accordion.Collapse>
 </Card>
  )
}
